const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

// Log API configuration on module load
console.log('[API] Initializing API service');
console.log('[API] API_BASE_URL:', API_BASE_URL);
console.log('[API] Environment:', process.env.NODE_ENV);

export const fetchEvents = async (startDate = null, endDate = null, includeInactive = true) => {
  const requestId = `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  
  try {
    console.log(`[API][${requestId}] fetchEvents called`, {
      startDate: startDate ? startDate.toISOString() : null,
      endDate: endDate ? endDate.toISOString() : null,
      includeInactive,
      apiBaseUrl: API_BASE_URL
    });

    let url = `${API_BASE_URL}/api/events?includeInactive=${includeInactive}`;
    
    if (startDate) {
      url += `&startDate=${startDate.toISOString()}`;
    }
    
    if (endDate) {
      url += `&endDate=${endDate.toISOString()}`;
    }

    console.log(`[API][${requestId}] Request URL:`, url);
    console.log(`[API][${requestId}] Starting fetch request...`);

    const startTime = performance.now();
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const endTime = performance.now();
    const duration = (endTime - startTime).toFixed(2);

    console.log(`[API][${requestId}] Response received`, {
      status: response.status,
      statusText: response.statusText,
      ok: response.ok,
      duration: `${duration}ms`,
      headers: Object.fromEntries(response.headers.entries())
    });
    
    if (!response.ok) {
      // Try to get error details from response body
      let errorDetails = null;
      try {
        const errorBody = await response.clone().json();
        errorDetails = errorBody;
        console.error(`[API][${requestId}] Error response body:`, errorBody);
      } catch (e) {
        const errorText = await response.clone().text();
        errorDetails = errorText;
        console.error(`[API][${requestId}] Error response text:`, errorText);
      }

      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      error.statusText = response.statusText;
      error.details = errorDetails;
      throw error;
    }
    
    console.log(`[API][${requestId}] Parsing response JSON...`);
    const data = await response.json();
    
    console.log(`[API][${requestId}] Successfully fetched events`, {
      eventCount: Array.isArray(data) ? data.length : 'N/A (not an array)',
      dataType: typeof data,
      sampleData: Array.isArray(data) && data.length > 0 ? data[0] : null
    });

    return data;
  } catch (error) {
    console.error(`[API][${requestId}] Error fetching events:`, {
      name: error.name,
      message: error.message,
      status: error.status,
      statusText: error.statusText,
      details: error.details,
      stack: error.stack,
      cause: error.cause
    });

    // Log network-specific errors
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      console.error(`[API][${requestId}] Network error detected - possible causes:`, {
        corsIssue: 'Check CORS configuration on backend',
        networkDown: 'Check network connectivity',
        wrongUrl: `Verify API URL: ${API_BASE_URL}`,
        sslError: 'Check SSL certificate if using HTTPS'
      });
    }

    throw error;
  }
};

/**
 * Fetches all configured tenant names from the API.
 * Used by Query Vault to populate the tenant dropdown.
 */
export const fetchTenants = async () => {
  const response = await fetch(`${API_BASE_URL}/api/queryvault/tenants`);
  if (!response.ok) throw new Error('Failed to fetch tenants');
  return response.json();
};

